import MicroModal from 'micromodal';

document.addEventListener('DOMContentLoaded', () => {
  const trigger = document.querySelector<HTMLElement>('[data-access-map]');
  if (!trigger) return;

  trigger.style.cursor = 'pointer';
  trigger.addEventListener('click', () => {
    MicroModal.show('modal-access-map', {
      disableScroll: true,
      awaitCloseAnimation: true,
    });
  });

  // ルート検索機能
  const groups = document.querySelectorAll<HTMLElement>('[data-group]');
  groups.forEach((group) => {
    const radios = group.querySelectorAll<HTMLInputElement>(
      'input[type="radio"]'
    );
    const textInput =
      group.querySelector<HTMLInputElement>('input[type="text"]');
    if (!textInput) return;

    textInput.addEventListener('focus', () => {
      radios.forEach((radio) => (radio.checked = false));
    });

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        textInput.value = '';
      });
    });
  });

  const routeLink = document.querySelector<HTMLAnchorElement>('#route-link');
  const routeError = document.querySelector<HTMLElement>('#route-error');
  if (!routeLink || !routeError) return;

  routeLink.addEventListener('click', (e) => {
    const getValue = (groupName: string): string => {
      const group = document.querySelector<HTMLElement>(
        `[data-group="${groupName}"]`
      );
      if (!group) return '';
      const checkedRadio = group.querySelector<HTMLInputElement>(
        'input[type="radio"]:checked'
      );
      if (checkedRadio) return checkedRadio.value;
      const textInput =
        group.querySelector<HTMLInputElement>('input[type="text"]');
      return textInput?.value.trim() || '';
    };

    const start = getValue('departure');
    const end = getValue('destination');

    if (!start || !end) {
      e.preventDefault();
      routeError.classList.remove('hidden');
      return;
    }

    routeError.classList.add('hidden');
    const url = `https://www.google.co.jp/maps/dir/${encodeURIComponent(start)}/${encodeURIComponent(end)}`;
    routeLink.href = url;
  });
});
